(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/most-played.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/most-played.js');

'use strict';

const formatAmount = svs.utils.format;
const MostPlayed = _ref => {
  let {
    mostPlayed,
    isExclusiveInOrder
  } = _ref;
  return React.createElement("div", {
    className: "most-played"
  }, React.createElement("div", {
    className: "coupon-stats-header"
  }, React.createElement("div", {
    className: "coupon-stats-header-text"
  }, "Mest spelade kombinationer"), React.createElement("div", {
    className: "coupon-stats-header-time"
  }, React.createElement("i", {
    className: "icon-default icon-clock-simple"
  }), React.createElement("span", null, mostPlayed.time))), React.createElement("div", {
    className: "most-played-data-row"
  }, React.createElement("div", {
    className: "most-played-col-desc left-col"
  }, "#"), React.createElement("div", {
    className: "most-played-col-desc center-col"
  }, "Oms\xE4ttning"), React.createElement("div", {
    className: "most-played-col-desc right-col"
  }, "H\xE4star (".concat(isExclusiveInOrder ? 'med' : 'utan', " inb\xF6rdes ord.)"))), mostPlayed.combinations.map(item => React.createElement("div", {
    className: "most-played-data-row",
    key: item.rank
  }, React.createElement("div", {
    className: "left-col"
  }, item.rank), React.createElement("div", {
    className: "center-col"
  }, formatAmount.Currency(formatAmount.CurrencyAsJupiterString(item.turnover)), ' ', "kr"), React.createElement("div", {
    className: "right-col"
  }, item.combination.map((item, i, arr) => React.createElement("span", null, arr.length - 1 === i ? item : "".concat(item, " - ")))))));
};
svs.racing_game.components.play.MostPlayed = MostPlayed;

 })(window);